export interface Tab {
  name: string;
  hidden: boolean;
  widgets: any[];
}

export interface Dashboard {
  id: number;
  name: string;
  isFavorite: boolean;
  tabs: Tab[];
}

export const DASHBOARD_TABS = {
  KEY_METRICS: 'Key Metrics',
  CALL_OVERVIEW: 'Calls',
  AGENT_PERFORMANCE: 'Users',
  CALL_QUALITY: 'Call Quality',
};

const DASHBOARD_KEY = 'dashboards';

export const DEFAULT_DASHBOARDS: Dashboard[] = [
  {
    id: 0,
    name: 'Default General',
    isFavorite: true,
    tabs: [
      {
        name: DASHBOARD_TABS.KEY_METRICS,
        hidden: true,
        widgets: []
      },
      {
        name: DASHBOARD_TABS.CALL_OVERVIEW,
        hidden: true,
        widgets: []
      },
      {
        name: DASHBOARD_TABS.AGENT_PERFORMANCE,
        hidden: false,
        widgets: []
      },
      {
        name: DASHBOARD_TABS.CALL_QUALITY,
        hidden: false,
        widgets: []
      }
    ]
  },
  {
    id: 1,
    name: 'Sales',
    isFavorite: false,
    tabs: [
      {
        name: DASHBOARD_TABS.KEY_METRICS,
        hidden: false,
        widgets: []
      },
      {
        name: DASHBOARD_TABS.CALL_OVERVIEW,
        hidden: false,
        widgets: []
      },
      {
        name: DASHBOARD_TABS.AGENT_PERFORMANCE,
        hidden: false,
        widgets: []
      },
      {
        name: DASHBOARD_TABS.CALL_QUALITY,
        hidden: false,
        widgets: []
      },
    ]
  },
  {
    id: 2,
    name: 'Support',
    isFavorite: false,
    tabs: [
      {
        name: DASHBOARD_TABS.KEY_METRICS,
        hidden: false,
        widgets: []
      },
      {
        name: DASHBOARD_TABS.CALL_OVERVIEW,
        hidden: false,
        widgets: []
      },
      {
        name: DASHBOARD_TABS.AGENT_PERFORMANCE,
        hidden: false,
        widgets: []
      },
      {
        name: DASHBOARD_TABS.CALL_QUALITY,
        hidden: false,
        widgets: []
      },
    ]
  }
];

export function GetDashboards(): any[] {
  const dashboards = localStorage.getItem(DASHBOARD_KEY);
  if (!dashboards) return DEFAULT_DASHBOARDS;
  const parsed: Dashboard[] = JSON.parse(dashboards);
  // Migrate old "Agents" tab name to "Users"
  let migrated = false;
  parsed.forEach(dashboard => {
    dashboard.tabs?.forEach(tab => {
      if (tab.name === 'Agents') {
        tab.name = 'Users';
        migrated = true;
      }
    });
  });
  if (migrated) localStorage.setItem(DASHBOARD_KEY, JSON.stringify(parsed));
  return parsed;
}

export function SaveDashboards(dashboards: any[]): void {
  localStorage.setItem(DASHBOARD_KEY, JSON.stringify(dashboards));
}

export function SetFavorite(id: number): void {
  const dashboards = GetDashboards();
  const updatedDashboards = dashboards.map(dashboard => {
    if (dashboard.id === id) {
      dashboard.isFavorite = true;
    }
    else {
      dashboard.isFavorite = false;
    }
    return dashboard;
  });
  SaveDashboards(updatedDashboards);
}

export function GetCurrentDashboard(): any {
  const dashboards = GetDashboards();
  const favorite = dashboards.find(d => d.isFavorite);
  return favorite || dashboards[0];
}
